<template>
  <div class="pro_item" @click="goDetail">
    <div class="img" :style="prolistItem.content ? {} : {'border-radius': '0.04rem'}">
      <img :id="prolistItem.itemid >= 0 ? ('loadingImg' + prolistItem.itemid) : ''" v-lazy="prolistItem.coverimg.indexOf('?x-oss-process') >= 0 ? prolistItem.coverimg : (prolistItem.coverimg + '?x-oss-process=image/format,jpg')" @online="error"/>
      <img v-if="prolistItem.isvideo == 1" class="isvideo" src="/static/images/community/video2.png">
      <star :star="prolistItem.star"></star>
    </div>
    <img v-if="prolistItem.istop == 1" class="isvideo top" src="/static/images/community/top.png">
    <div class="foot" v-if="prolistItem.content">
      <div class="tit over-ell-1 f16" v-if="prolistItem.title" style="font-weight: bold;">
        {{prolistItem.title}}
      </div>
      <div class="tit over-ell-2 f14">
        {{prolistItem.content}}
      </div>
      <div class="userinfo">
        <div class="user flex-ac">
          <head-pendant :identity="prolistItem.identity">
            <img v-if="prolistItem.authorhead" :src="prolistItem.authorhead" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}"/>
            <img v-if="!prolistItem.authorhead" :src="errorHeadImg"/>
          </head-pendant>
          <span class="over-ell-1">{{prolistItem.authorname}}</span>
        </div>
        <div class="sj" @click.stop="likeFn">
          <img v-if="prolistItem.ispraise == 0" src="/static/images/community/notlike.png">
          <img v-if="prolistItem.ispraise == 1" src="/static/images/community/like.png">
          <p>{{prolistItem.praisenum}}</p>
        </div>
      </div>
      <div class="topic flex-ac" v-if="prolistItem.subject" @click.stop="goSubjectid">
        <img width="14" height="14" src="/static/images/community/community-topic-selected.png">
        <span class="f12">{{prolistItem.subject}}</span>
      </div>
    </div>
<!--    <div class="product" v-if="prolistItem.gooditemid" @click.stop="goProdetail">-->
<!--      <div>-->
<!--        <img v-lazy="prolistItem.goodimg">-->
<!--        <div class="name">-->
<!--          <p>{{prolistItem.goodname}}</p>-->
<!--          <span>¥{{prolistItem.goodsaleprice}}</span>-->
<!--        </div>-->
<!--        <van-icon name="arrow" color="#FC0324" size="0.15rem" />-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import Star from './star'
import headPendant from './headPendant'
export default {
  name: 'productItem',
  components: {
    Star,
    headPendant
  },
  props: {
    prolistItem: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    error (e) {
      console.log(e)
    },
    goDetail () {
      if (this.prolistItem.type == 0) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'postsad',
            buttontext: this.prolistItem.ad_title
          },
          callback: () => {
            if (this.prolistItem.url) {
              window.location = this.prolistItem.url
            } else {
              this.$clickburiedPoint({
                url: 'ckysdatacenter/itemclick/save',
                data: {
                  itemid: this.prolistItem.itemid,
                  scenepoint: 'postsad',
                  scenedesc: this.prolistItem.ad_title
                },
                callback: () => {
                  this.$router.push({
                    path: '/productdetail',
                    query: {
                      itemid: this.prolistItem.itemid
                    }
                  })
                }
              })
            }
          }
        })
        return
      }
      var id = this.prolistItem.itemid
      this.$router.push({
        path: '/communitydetail',
        query: {
          id: id
        }
      })

      // this.$router.go()
      // window.location.href = '/productdetail?itemid=' + id
    },
    goSubjectid: function () {
      this.$router.push({
        path: '/communityfollow',
        query: {
          subjectid: this.prolistItem.subjectid,
          subject: encodeURIComponent(this.prolistItem.subject)
        }
      })
    },
    likeFn: function () {
      var url = 'Wxmall/CommunityPosts/likes', data = {
        type: 0,
        ispraise: this.prolistItem.ispraise == 0 ? 1 : 0,
        postsid: this.prolistItem.itemid
      }
      customRequestAjax.post(url, data).then(res => {
        if (res.data.code == 200) {
          if (this.prolistItem.ispraise == 0) {
            this.prolistItem.ispraise = 1
            this.prolistItem.praisenum++
          } else {
            this.prolistItem.ispraise = 0
            this.prolistItem.praisenum--
          }
        }
      })
    },
    goProdetail: function () {
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: this.prolistItem.gooditemid
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .pro_item {
    position: relative;
    margin-bottom: .1rem;
    border-radius: 0.04rem;
    background: #fff;
    /*overflow: hidden;*/
    .img {
      width: 100%;
      /*height: 1.67rem;*/
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      border-radius: 0.04rem 0.04rem 0 0;
      img {
        width: 100%;
      }
    }
    .foot {
      padding: .08rem 0.1rem;
      overflow: hidden;
    }
    .tit {
      /*line-height: .18rem;*/
      margin-bottom: 0.02rem;
      word-wrap:break-word;
      color: #292929;
    }
    .userinfo {
      margin-top: 0.1rem;
      display: flex;
      justify-content: space-between;
      .user {
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.12rem;
        margin-right: 0.05rem;
        img {
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          object-fit: cover;
        }
        span {
          color: #292929;
          font-size: 0.12rem;
          margin-left: 0.1rem;
        }
      }
      .sj {
        z-index: 9;
        font-size: .1rem;
        text-align: right;
        height: 0.2rem;
        display: flex;
        align-items: center;
        img {
          width: 0.14rem;
          height: 0.14rem;
        }
        p {
          color: #969696;
          font-size: 0.1rem;
          margin-left: 0.05rem;
        }
      }
    }
    .topic {
      color: #FC0324;
      padding-top: 0.07rem;
      margin-top: 0.08rem;
      border-top: 0.01rem solid #EEEEEE;
      img {
        margin-right: 0.04rem;
      }
    }
    .product {
      padding: 0 0.1rem 0.12rem;
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 0.01rem;
        background: #D8D8D8;
      }
      >div {
        padding-top: 0.09rem;
        display: flex;
        align-items: center;
        img {
          width: 0.57rem;
          height: 0.57rem;
          border: 0.04rem;
        }
        .name {
          height: 0.57rem;
          max-width: 0.69rem;
          flex: 1;
          margin-left: 0.08rem;
          margin-right: 0.04rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p {
            color: #292929;
            font-size: 0.13rem;
            line-height: 0.18rem;
            word-wrap:break-word;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          span {
            display: block;
            color: #FC0324;
            font-size: 0.14rem;
            margin-top: 0.02rem;
            word-wrap:break-word;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/communityItem.vue